require('/opt/odin/app/frontend/components/modals/setup/index.module.scss');
require('/opt/odin/app/frontend/components/modals/setup/images/loading.svg');module.exports = "../../app/cells/components/modals/setup/show.erb";